import React from "react";
import FieldDropdownDynamic from "../../../generic/dropdown-dynamic/dropdown-dynamic";
import FieldConfig from "../../../proto/field-config";
import NavigationSection from "../../../../model2/navigation/navigation-section";
import {NavigationButtonPosition, NavigationSectionType} from "../../../../model2/navigation/@const";
import FieldNavigationDisplayIn_GListEditable from "./render/glist-editable";
import {ViewType} from "../../../../gd/const/views/view-type"

const OptionNavigationPanelBottom = {
    label       : 'Navigation panel',
    value       : NavigationButtonPosition.BOTTOM
}

const OptionNavigationPanelTop = {
    label       : 'Navigation panel',
    value       : NavigationButtonPosition.TOP
}

const OptionNavigationPanelMore = {
    label       : 'More menu',
    value       : NavigationButtonPosition.MORE
}

export default class FieldNavigationDisplayIn extends FieldDropdownDynamic {


    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Display In";

        this.options = [
            OptionNavigationPanelBottom,
            OptionNavigationPanelTop,
            OptionNavigationPanelMore
        ]

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = false

        // Label for no value option
        // this.noValueOptionLabel = _.get(config,'noValueOptionLabel','No contact');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.icon = 'i5-crm-contact';

        this.isSearchable = true;

        this.components.PopoverMenuMore = false

        this.renderComponents.glistEditable     = FieldNavigationDisplayIn_GListEditable
    }

    getOptionsForEdit(model:NavigationSection):Option[] {

        // Custom View
        if (model.customView) {
            switch (model.customView.type) {
                case ViewType.MY_ATTENDANCE:
                    return [
                        OptionNavigationPanelTop,
                    ]

                default:
                    return [
                        OptionNavigationPanelTop,
                        OptionNavigationPanelMore
                    ]
            }
        }


        switch (model.type) {
            case NavigationSectionType.MORE         :
            case NavigationSectionType.HOME         :
                return [
                    OptionNavigationPanelTop,
                ]
            case NavigationSectionType.PROJECTS     :
            case NavigationSectionType.TOOLS        :
            case NavigationSectionType.CHATS        :
            case NavigationSectionType.USERS        :
            case NavigationSectionType.QUICK_ADD    :
            case NavigationSectionType.REPORTS    :
            case NavigationSectionType.CRM    :
                return [
                    OptionNavigationPanelTop,
                    OptionNavigationPanelMore
                ]

            case NavigationSectionType.SEARCH       :
                return [
                    OptionNavigationPanelBottom,
                    OptionNavigationPanelMore
                ]
            case NavigationSectionType.HELP         :
            case NavigationSectionType.SETTINGS     :
                return [
                    // OptionNavigationPanelBottom,
                    OptionNavigationPanelMore
                ]

            case NavigationSectionType.MY_ACCOUNT   :
                return [
                    OptionNavigationPanelBottom
                ]

            default:
                return [
                    OptionNavigationPanelTop
                ]
        }
    }
}
